import { Component } from '@angular/core';
import {
  NbAuthToken,
  NbTokenService,
} from '@nebular/auth';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../auth.service';
const Lockr = require("lockr");
import jwt_decode from 'jwt-decode';

@Component({
  selector: 'ngx-login',
  templateUrl: './actAsUser.component.html',
})
export class ActAsUserComponent {
  errors: string[] = [];
  messages: string[] = [];
  userId: any = '';
  submitted: boolean = false;
  tkn: string;

  constructor(
    protected tokenService: NbTokenService,
    protected router: Router,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
  ) {
    this.tokenService.clear();
    this.activatedRoute.queryParamMap.subscribe(params => {
      this.tkn = params.get('id');
      this.login();
    });
  }

  async login() {
    if (this.tkn) {
      localStorage.clear();
      Lockr.rm('access_token');
      Lockr.set('user');

      localStorage.optc = 1;
      localStorage.test = 1;
      const tokenDecoded: any = jwt_decode(this.tkn);
      Lockr.set('access_token', this.tkn);
      Lockr.set('user', tokenDecoded);
      localStorage.auth_app_token = JSON.stringify({
        value: JSON.stringify({
          access_token: this.tkn,
          refresh_token: 'invalidRefreshToken',
        }),
        ownerStrategyName: 'email',
        name: 'nb:auth:oauth2:jwt:token',
        createdAt: new Date().getTime(),
      });
      window.location.href = '/pages/notificaciones';
    } else {
      this.router.navigateByUrl('/auth/login');
    }
  }
}
